module.exports = __webpack_public_path__ + "img/pin.aff129b5.svg";